module.exports = __webpack_public_path__ + "img/pic_title_img2.90da6716.png";